module.exports = __webpack_public_path__ + "static/media/pdf-gray.f83d1883.svg";